import fixURI from "@/utils/fixURI";

export default function configureProductVariant(
  productVariantResponse: ProductVariantResponse,
): ProductAttributeState[] {
  const productAttributeStates: ProductAttributeState[] = [];

  //Map server response to Product Atribute State
  productVariantResponse.productAttributeValues.forEach((productAttribute) => {
    const attribute: ProductAttribute | undefined = productVariantResponse.attributes.find(
      (attribute) => attribute.attributeId === productAttribute.attributeId,
    );

    if (attribute) {
      const productAttributeOptions: ProductAttributeOption[] = attribute.attributeValues.map((attributeValue) => {
        return {
          attributeId: productAttribute.attributeId,
          atributeName: productAttribute.attributeName,
          attributeValueId: attributeValue.attributeValueId,
          attributeValue: attributeValue.attributeValueName,
          mpId: 0,
          isValidCombination: false,
          url: "",
        };
      });

      productAttributeStates.push({
        selectedAttributeId: productAttribute.attributeId,
        selectedAttributeName: productAttribute.attributeName,

        selectedAttributeValueId: productAttribute.attributeValueId,
        selectedAttributeValue: productAttribute.attributeValue,

        productAttributeOptions: productAttributeOptions,
      });
    }
  });

  // Fill up available combinations
  productAttributeStates.forEach((productAttributeState) => {
    const productAttributeOptions: ProductAttributeOption[] = productAttributeStates
      .filter((a) => a.selectedAttributeId !== productAttributeState.selectedAttributeId)
      .map((a) => {
        return {
          attributeId: a.selectedAttributeId,
          atributeName: a.selectedAttributeName,

          attributeValueId: a.selectedAttributeValueId,
          attributeValue: a.selectedAttributeValue,
          mpId: 0,
          isValidCombination: false,
          url: "",
        };
      });

    productAttributeState.productAttributeOptions.forEach((productAttributeOption) => {
      const atributeCombinationArray: ProductAttributeOption[] = [];
      atributeCombinationArray.push(productAttributeOption);
      productAttributeOptions.forEach((productAttribute) => atributeCombinationArray.push(productAttribute));

      for (let i = 0; i < productVariantResponse.productsInVariantGroup.length; i++) {
        const productInVariantGroup = productVariantResponse.productsInVariantGroup[i];

        const attributeValues = productInVariantGroup.attributeValues.filter((attribute) => {
          const productAtributeValue = atributeCombinationArray.find(
            (attributeCombination) =>
              attributeCombination.attributeId === attribute.attributeId &&
              attributeCombination.attributeValueId === attribute.attributeValueId,
          );

          if (productAtributeValue) {
            return true;
          }
          return false;
        });

        if (attributeValues && attributeValues.length === atributeCombinationArray.length) {
          productAttributeOption.mpId = productInVariantGroup.mpId;
          productAttributeOption.isValidCombination = true;
          productAttributeOption.url = fixURI(productInVariantGroup.url);
          break;
        }
      }
    });
  });

  // Fill up combinations not available, grab first available
  productAttributeStates.forEach((productAttributeState) => {
    productAttributeState.productAttributeOptions.forEach((productAttributeOption) => {
      if (productAttributeOption.mpId === 0) {
        for (let i = 0; i < productVariantResponse.productsInVariantGroup.length; i++) {
          const productInVariantGroup = productVariantResponse.productsInVariantGroup[i];
          const attributeValue = productInVariantGroup.attributeValues.find(
            (attribute) =>
              attribute.attributeId === productAttributeOption.attributeId &&
              attribute.attributeValueId === productAttributeOption.attributeValueId,
          );

          if (attributeValue) {
            productAttributeOption.mpId = productInVariantGroup.mpId;
            productAttributeOption.url = fixURI(productInVariantGroup.url);
            break;
          }
        }
      }
    });
  });

  return productAttributeStates;
}
